import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setReportPresets = payload =>
  call(websocketFetch, 'set_report_presets', payload);
